import { gql } from "react-apollo";

export const GENERATE_QR_CODE = "GENERATE_QR_CODE";
export const GENERATE_QR_CODE_START = "GENERATE_QR_CODE_START";
export const GENERATE_QR_CODE_SUCCESS = "GENERATE_QR_CODE_SUCCESS";
export const GENERATE_QR_CODE_ERROR = "GENERATE_QR_CODE_ERROR";

const query = gql`
  query generateQRCode($userId: String!, $email: String!) {
    generateQRCode(userId: $userId, email: $email) {
      success
      data {
        qrCodeImage
        verificationData {
          userId
          email
          timestamp
          expiresAt
        }
      }
      error
    }
  }
`;

export const generateQRCode =
  (userId, username, listId) => async (dispatch) => {
    dispatch({ type: GENERATE_QR_CODE_START });

    try {
      const response = await fetch("/graphql", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: `
          mutation CreateDocuPass($input: DocuPassInput!) {
            createDocuPass(input: $input) {
              status
              message
              error
              code
              reference
              url
              qrCode
              createdAt
              completedAt
            }
          }
        `,
          variables: {
            input: {
              userId,
              username,
              ...(listId ? { listId } : {}),
            },
          },
        }),
      });

      const result = await response.json();

      if (result.data?.createDocuPass) {
        const { createDocuPass } = result.data;

        if (createDocuPass.status === "success") {
          dispatch({
            type: GENERATE_QR_CODE_SUCCESS,
            payload: {
              qrCode: createDocuPass.qrCode,
              reference: createDocuPass.reference,
              url: createDocuPass.url,
              message: createDocuPass.message,
              code: createDocuPass.code,
            },
          });
        } else {
          dispatch({
            type: GENERATE_QR_CODE_ERROR,
            payload: {
              error: createDocuPass.error,
              code: createDocuPass.code,
              status: createDocuPass.status,
            },
          });
        }
      }
    } catch (error) {
      dispatch({
        type: GENERATE_QR_CODE_ERROR,
        payload: {
          error: "Failed to generate QR code",
          code: "500",
          status: "error",
        },
      });
    }
  };
